import * as React from 'react';
import { designSystemConfig, isThemeColor } from '@mentimeter/ragnar-dsc';
import { withTheme } from '@mentimeter/ragnar-react';
import { useTranslations } from 'use-intl';
import type { DefaultIconT, IconT } from '../legacy-system-icon';
import { Svg } from '../svg';
import {
  HeartSolidIcon,
  ThumbsUpSolidIcon,
  ThumbsDownSolidIcon,
  MessageSolidIcon,
  QASolidIcon,
  UserSolidIcon,
} from '../functional-icons';

const ReactionIcon = ({
  size = 2,
  color = 'text',
  children,
  theme = designSystemConfig,
  'aria-label': ariaLabel,
}: React.PropsWithChildren<DefaultIconT>) => (
  <Svg
    viewBox="0 0 24 24"
    height={typeof size === 'number' ? theme.fontSizes[size] || size : size}
    width={typeof size === 'number' ? theme.fontSizes[size] || size : size}
    aria-label={ariaLabel}
  >
    <g fill={isThemeColor(theme, color) ? theme.colors[color] : color}>
      {children}
    </g>
  </Svg>
);

const Icon = withTheme<DefaultIconT>(ReactionIcon);

export function CatReaction(props: IconT) {
  const t = useTranslations('ragnar.reactions');
  return (
    <Icon aria-label={t('cat_reaction_icon_label_a11y')} {...props}>
      <path d="M17.37 6.36A11.64 11.64 0 0012 5.28a11.64 11.64 0 00-5.37 1.08l-3.91-3.9a.6.6 0 00-1 .42v11.57c.27 6.36 7.12 7.76 9.5 8.05a6.35 6.35 0 001.63 0c2.38-.29 9.22-1.7 9.49-8.06V2.88a.6.6 0 00-1-.43z" />
    </Icon>
  );
}

export function HeartReaction(props: IconT) {
  const t = useTranslations('ragnar.reactions');

  return (
    <HeartSolidIcon
      aria-label={t('heart_reaction_icon_label_a11y')}
      {...props}
    />
  );
}

export function ThumbsUpReaction(props: IconT) {
  const t = useTranslations('ragnar.reactions');

  return (
    <ThumbsUpSolidIcon
      aria-label={t('thumbs_up_reaction_icon_label_a11y')}
      {...props}
    />
  );
}

export function ThumbsDownReaction(props: IconT) {
  const t = useTranslations('ragnar.reactions');

  return (
    <ThumbsDownSolidIcon
      aria-label={t('thumbs_down_reaction_icon_label_a11y')}
      {...props}
    />
  );
}

export function QuestionReaction(props: IconT) {
  const t = useTranslations('ragnar.reactions');

  return (
    <Icon aria-label={t('question_reaction_icon_label_a11y')} {...props}>
      <path d="M14.61 7.7c0-1.27-.9-2-2.5-2A3.17 3.17 0 009.45 7a1.42 1.42 0 01-1.84.42l-.85-.49a1.4 1.4 0 01-.45-2A7.06 7.06 0 0112.25 2c3.11 0 6.16 1.87 6.16 5.42s-3.6 5-4.45 7a1.35 1.35 0 01-1.26.81h-.91a1.4 1.4 0 01-1.21-2.11c1.25-2.12 4.03-3.31 4.03-5.42zm-5.06 12a2.34 2.34 0 112.34 2.3 2.34 2.34 0 01-2.34-2.34z" />
      {/* Extra bold <path d="M14.2 7.88c0-1-.63-1.59-2-1.59a2.84 2.84 0 00-2.43 1.27A1.29 1.29 0 018.09 8L6.47 7A1.25 1.25 0 016 5.29 7.36 7.36 0 0112.33 2c3.13 0 6.26 1.92 6.26 5.49s-3.39 5-4.21 6.59a1.27 1.27 0 01-1.12.67h-1.78a1.27 1.27 0 01-1.09-1.94c1.2-1.91 3.81-3.07 3.81-4.93zM9.39 19.39A2.61 2.61 0 1112 22a2.62 2.62 0 01-2.61-2.61z" /> */}
    </Icon>
  );
}

export function QfaIndicator(props: IconT) {
  const t = useTranslations('ragnar.reactions');

  return (
    <QASolidIcon
      aria-label={t('questions_from_audience_indicator_icon_label_a11y')}
      {...props}
    />
  );
}

export function VoteIndicator(props: IconT) {
  const t = useTranslations('ragnar.reactions');

  return (
    <UserSolidIcon
      aria-label={t('vote_indicator_icon_label_a11y')}
      {...props}
    />
  );
}

export function CommentIndicator(props: IconT) {
  const t = useTranslations('ragnar.reactions');

  return (
    <MessageSolidIcon
      aria-label={t('comment_indicator_icon_label_a11y')}
      {...props}
    />
  );
}
